import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarTipoPeriodo from "./AgregarTipoPeriodo/AgregarTipoPeriodo";
import EditarTipoPeriodo from "./EditarTipoPeriodo/EditarTipoPeriodo";

moment.locale("es");

const DIAS_SEMANA_LABELS = {
  0: "Domingo",
  1: "Lunes",
  2: "Martes",
  3: "Miércoles",
  4: "Jueves",
  5: "Viernes",
  6: "Sábado",
};

class TiposPeriodos extends Component {
  tableRef = null;
  state = {
    todosTiposPeriodos: [],
    loading: false,
    valor: 1,
    modalAgregarTipoPeriodo: false,
    modalEditarTipoPeriodo: false,
    modalEditarTipoPeriodoId: null,
  };

  consultarTiposPeriodos(params) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposPeriodos/selectTodasTiposPeriodos",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          this.setState({ todosTiposPeriodos: [] });
        } else {
          this.setState({
            todosTiposPeriodos: res.data.data,
            totalRecords: res.data.totalRecords || 0,
          });
        }
      });
  }

  deshabilitarTipoPeriodo(value) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposPeriodos/deshabilitarTipoPeriodo",
        { tipoPeriodoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Tipo de periodo deshabilitado");
        } else {
          message.error("Sucedió un error y no se pudo deshabilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }

  habilitarTipoPeriodo(value) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposPeriodos/habilitarTipoPeriodo",
        { tipoPeriodoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Tipo de periodo habilitado");
        } else {
          message.error("Sucedió un error y no se pudo habilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }

  agregarTipoPeriodo() {
    this.setState({ modalAgregarTipoPeriodo: true });
  }

  cerrarAgregarTipoPeriodo() {
    this.setState({ modalAgregarTipoPeriodo: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  editarTipoPeriodo(id) {
    this.setState({ modalEditarTipoPeriodo: true, modalEditarTipoPeriodoId: id });
  }

  cerrarEditarTipoPeriodo() {
    this.setState({ modalEditarTipoPeriodo: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  render() {
    const columns = [
      {
        title: "Número",
        dataIndex: "numero",
        key: "numero",
        buscar: "serieNumero",
        render: (value, record) => `${record.serie} - ${record.numero}`,
        width: "6%",
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        buscar: "nombre",
        width: "16%",
      },
      {
        title: "Días Periodo",
        dataIndex: "diasPeriodo",
        key: "diasPeriodo",
        width: "8%",
      },
      {
        title: "Días de Pago",
        dataIndex: "diasDePago",
        key: "diasDePago",
        width: "8%",
      },
      {
        title: "Periodo Trabajo",
        dataIndex: "periodoTrabajo",
        key: "periodoTrabajo",
        width: "8%",
      },
      {
        title: "Día de Pago",
        dataIndex: "diaDePago",
        key: "diaDePago",
        width: "8%",
        render: (value) => DIAS_SEMANA_LABELS[value] ?? "—",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "8%",
        render: (value) => {
          if (value === 0) return <Tag color="red">Cancelado</Tag>;
          if (value === 1) return <Tag color="green">Activo</Tag>;
          if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
          return "—";
        },
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        width: "10%",
        render: (value, record) => {
          let buttons = [];

          buttons.push(
            <Tooltip
              key={`tooltip-editar-${record._id}`}
              title="Editar Tipo de Periodo"
              placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
            >
              <ButtonItem
                key={`editar-${record._id}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.editarTipoPeriodo(record._id)}
              />
            </Tooltip>
          );

          if (record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${record._id}`}
                title="¿Seguro que quieres deshabilitar este tipo de periodo?"
                onConfirm={() => this.deshabilitarTipoPeriodo(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Deshabilitar"
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  />
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${record._id}`}
                title="¿Seguro que quieres habilitar este tipo de periodo?"
                onConfirm={() => this.habilitarTipoPeriodo(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Habilitar"
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  />
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Tipos de Periodos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Vigente", value: 1 },
                    { label: "Deshabilitado", value: 2 },
                    { label: "Todos", value: 3 },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                    }
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              <ButtonItem
                type="primary"
                key="agregarTipoPeriodo"
                onClick={this.agregarTipoPeriodo.bind(this)}
              >
                Agregar Tipo de Periodo
              </ButtonItem>
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarTiposPeriodos.bind(this)}
          anadirValorFiltro={this.state.valor}
          size="small"
          onlyMineFilter
          dataSource={this.state.todosTiposPeriodos}
          columns={columns}
          scroll={{ x: "max-content" }}
          filterStorageKey={"tiposPeriodos" + this.props.empresaId}
          onRow={(record) => ({
            onDoubleClick: () => {
              this.editarTipoPeriodo(record._id);
            },
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
        />
        <AgregarTipoPeriodo
          visible={this.state.modalAgregarTipoPeriodo}
          cerrarAgregarTipoPeriodo={this.cerrarAgregarTipoPeriodo.bind(this)}
        />
        <EditarTipoPeriodo
          visible={this.state.modalEditarTipoPeriodo}
          tipoPeriodoId={this.state.modalEditarTipoPeriodoId}
          cerrarEditarTipoPeriodo={this.cerrarEditarTipoPeriodo.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(TiposPeriodos);